import {CtModelRouteData} from "@ctsolution/ct-framework";

export const ItemRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("item");
